/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import { getSession, signOut } from "next-auth/react";

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:3000",
});

/**
 * ✅ Request Interceptor
 * - Adds Authorization header
 * - Sets Content-Type conditionally
 */
api.interceptors.request.use(
  async (config: any) => {
    // Ensure headers object exists
    config.headers = config.headers ?? {};

    // 🔹 Detect FormData
    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;

    // 🔹 Set Content-Type conditionally
    if (!isFormData && !config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    // 🔹 Attach token (client-side only)
    if (typeof window !== "undefined") {
      const session = await getSession();
      if (session?.accessToken) {
        config.headers.Authorization = `Bearer ${session.accessToken}`;
      }
    }

    return config;
  },
  (error: any) => Promise.reject(error)
);

/**
 * ✅ Response Interceptor
 * - Auto logout on 401
 */
api.interceptors.response.use(
  (response: any) => response,
  async (error: any) => {
    if (typeof window !== "undefined" && error.response?.status === 401) {
      await signOut({ callbackUrl: "/signin" });
    }
    return Promise.reject(error);
  }
);

export default api;
